import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { obtenerTotalAlmacenaje } from '../../actions/listados'
import TotalAlmacenajeView from '../../components/listados/TotalAlmacenajeView'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_ALMACENAJE_MERCADERIA } from '../../../../config/forms'
import CamposBusqueda from '../../components/listados/CamposBusqueda'
import { parseEntityId } from '../../../../models/entity'

function TotalAlmacenaje (props) {
  const { obtenerTotalAlmacenaje, change: formChange } = props

  useEffect(() => {
    obtenerTotalAlmacenaje(new Date(), new Date())
  }, [obtenerTotalAlmacenaje])

  const actualizarFechas = (fechaD, fechaH) => {
    formChange('fechaDesde', fechaD)
    formChange('fechaHasta', fechaH)
  }

  const handleSubmit = () => {
    const { fechaDesde, fechaHasta, exportador, cereal } = props
    const exportadorAlmacenaje = parseEntityId(exportador) || null
    const cerealAlmacenaje = (cereal && (cereal.trim() !== 'UNDEF') && cereal.trim()) || null
    obtenerTotalAlmacenaje(fechaDesde, fechaHasta, exportadorAlmacenaje, cerealAlmacenaje)
  }

  return (
    <>
      <CamposBusqueda actualizarFechas={actualizarFechas} handleSubmit={handleSubmit} />
      <TotalAlmacenajeView />
    </>
  )
}

const selector = formValueSelector(FORM_ALMACENAJE_MERCADERIA)

const mapStateToProps = (state) => ({
  cereal: selector(state, 'cereal')
})

const mapActionsToProps = {
  obtenerTotalAlmacenaje
}

const withReduxForm = reduxForm({
  form: FORM_ALMACENAJE_MERCADERIA
})
const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(TotalAlmacenaje))
